import { c as _c } from "react/compiler-runtime";
import type { CartOutputDto } from "@sticker-giant/sg-frontend-common";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconStar } from "@tabler/icons-react";
import { Skeleton } from "@/components/ui/skeleton";
import { useIsCartMutating } from "@/queries/useIsCartMutating";
interface Props {
  cart: CartOutputDto;
}
export function OrderSummarySitewidePromo(t0) {
  const $ = _c(11);
  const {
    cart
  } = t0;
  const isMutating = useIsCartMutating();
  if (!cart.pricing.siteWideDiscountTotal) {
    return null;
  }
  let t1;
  if ($[0] !== cart.items) {
    t1 = Array.from(new Set(cart.items.map(_temp).filter(Boolean)));
    $[0] = cart.items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const descriptions = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-0.5 flex items-center gap-2"><IconStar size={16} /><span className="font-medium">Sitewide Promotion</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== descriptions) {
    t3 = <div className="flex flex-col text-sm">{t2}{descriptions.map(_temp2)}</div>;
    $[3] = descriptions;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== cart.pricing.siteWideDiscountTotal || $[6] !== isMutating) {
    t4 = isMutating ? <Skeleton className="h-4 w-16 bg-neutral-200" /> : <span className="font-medium text-green-600">{`-${CurrencyFormatter.formatUSD(cart.pricing.siteWideDiscountTotal)}`}</span>;
    $[5] = cart.pricing.siteWideDiscountTotal;
    $[6] = isMutating;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex justify-between">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(desc) {
  return <span key={desc} className="text-neutral-500">{desc}</span>;
}
function _temp(item) {
  return item.siteWideDiscountDescription;
}